import { utils } from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";

import { QUARRY_ADDRESSES } from "../../constants";

export const findActivityMasterAddress = async (
  programID: PublicKey = QUARRY_ADDRESSES.Activity
): Promise<[PublicKey, number]> => {
  return await PublicKey.findProgramAddress(
    [Buffer.from(utils.bytes.utf8.encode("activity"))],
    programID
  );
};

export const findActivityMetadataAddress = async (
  mint: PublicKey,
  programID: PublicKey = QUARRY_ADDRESSES.Activity
): Promise<[PublicKey, number]> => {
  return await PublicKey.findProgramAddress(
    [Buffer.from(utils.bytes.utf8.encode("activity")), mint.toBytes()],
    programID
  );
};
